import React, { createContext, useContext, useState, useCallback, useEffect } from "react";

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [cartItems, setCartItems] = useState(() => {
    // Optionally load from local storage
    const stored = localStorage.getItem("training-center-cart");
    return stored ? JSON.parse(stored) : [];
  });

  useEffect(() => {
    localStorage.setItem("training-center-cart", JSON.stringify(cartItems));
  }, [cartItems]);

  const addToCart = useCallback((course) => {
    setCartItems((prev) => {
      if (prev.find((item) => item.id === course.id)) return prev;
      return [...prev, course];
    });
    setIsCartOpen(true);
    setTimeout(() => {
      setIsCartOpen(false);
    }, 3000);
  }, []);

  const removeFromCart = useCallback((courseId) => {
    setCartItems((prev) => prev.filter((item) => item.id !== courseId));
  }, []);

  const clearCart = useCallback(() => {
    setCartItems([]);
  }, []);

  const isInCart = useCallback(
    (courseId) => !!cartItems.find((item) => item.id === courseId),
    [cartItems]
  );

  return (
    <CartContext.Provider
      value={{ cartItems, addToCart, removeFromCart, clearCart, isInCart, isCartOpen, setIsCartOpen }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error("useCart must be used within a CartProvider");
  }
  return context;
};
